import { IS_DEV_ENV } from '../../envs'

export const API_ORIGIN = IS_DEV_ENV ? 'http://localhost:3001/api' : '/api';
// export const API_ORIGIN = IS_DEV_ENV ? 'http://192.168.0.17:3001/api' : '/api';